const toggleBtn = document.querySelector('[data-toggle-content]');

const toggleOrderSummaryProducts = () => {
    if (!toggleBtn) {
        return;
    }

    const toggleContent = document.querySelector(`.${toggleBtn.dataset.toggleContent}`);
    const toggleBtnLabel = toggleBtn.querySelector('.button-label');

    toggleBtn.addEventListener('click', () => {
        const {
            dataset: {
                contentCollapsed
            }
        } = toggleContent;
        const state = contentCollapsed === '1' ? 0 : 1;

        if (toggleBtnLabel) {
            toggleBtnLabel.textContent = state ? 'Show all' : 'Show less';
        }

        toggleBtn.dataset.contentCollapsed = state;
        toggleContent.dataset.contentCollapsed = state;
        if (state) {
            window.scrollTo({
                top: toggleContent.parentElement.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }
    });
};

export default toggleOrderSummaryProducts;
